/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMuseum = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 2v2.998l4 .001v2l-3-.001V17h3v4.999H2V17h3V6.998l-3 .001v-2l4-.001V2zm2 17H4v.999L20 20zM13 6.998h-2V17h2zm-4 .001H7v10h2zm8 0h-2v10h2zm-1-3H8v1h8z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMuseum as Museum };
